import { createSection } from '../createSection'

/**
 * Suffix section
 *
 * @public
 */
export const suffix = createSection('suffix', null)
